import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont } from '../../theme/fundingTypography'
import {
  fundingModalPaper,
  fundingModalTitle,
  fundingModalTitleIcon,
} from '../../theme/fundingSharedStyles'

export const useStyles = makeStyles()(() => ({
  paper: {
    ...fundingModalPaper,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleIcon: {
    ...fundingModalTitleIcon,
  },
  title: {
    ...fundingModalTitle,
  },
  divider: {
    alignSelf: 'stretch',
    width: 1,
    flexShrink: 0,
    borderRadius: 4,
    backgroundColor: C.divider,
  },
  noteLine: {
    display: 'block',
    marginTop: 4,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  help: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
    padding: 0,
    border: 'none',
    background: 'none',
    textDecoration: 'none',
    color: C.linkBlue,
    cursor: 'pointer',
    '& svg': { fontSize: 16 },
  },
  helpText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.linkBlue,
    whiteSpace: 'nowrap',
  },
  close: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    '& svg': { fontSize: 24, color: C.mutedText },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  bodyText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
    whiteSpace: 'pre-wrap',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12,
    width: '100%',
  },
  button: {
    boxSizing: 'border-box',
    height: 32,
    padding: '6px 16px',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.strongText,
  },
  cancelButton: {
    backgroundColor: C.cardBg,
    border: `1px solid ${C.stepUpcomingBorder}`,
  },
  proceedButtonWithIcon: {
    gap: 6,
    paddingRight: 12,
  },
  proceedButton: {
    backgroundColor: C.ctaFill,
    // Match Funding Save / primary CTAs — dark label on orange (not white).
    color: C.darkText,
    border: 'none',
  },
}))
